<template>
  <Layout>
    <template #sidebar>
      <RouterView name="sidebar" />
    </template>

    <template #default="{ showMenu }">
      <div class="flex flex-col h-full">
        <header class="py-2 bg-white border-b border-gray-400 z-20">
          <div class="max-w-5xl mx-auto px-2">
            <div class="flex -mx-2 items-center">
              <div class="flex-none px-2 lg:hidden">
                <button class="btn btn-brand style-link" @click="showMenu">
                  <FontAwesomeIcon icon="bars" />
                </button>
              </div>
              <div class="w-64 px-2">
                <RouterLink to="/">
                  <h6 class="text-black">
                    <span class="text-indigo-600">Digi</span> Cloud &trade;
                  </h6>
                </RouterLink>
              </div>
              <template v-if="$user">
                <div class="flex-1 px-2" />
                <div class="px-2">
                  <QuickMenu />
                </div>
              </template>
            </div>
          </div>
        </header>
        <main class="flex flex-1 flex-col overflow-y-auto h-full">
          <RouterView />
        </main>
      </div>
    </template>
  </Layout>
</template>

<script>
import Layout from '@/layouts/OffCanvasLayout.vue';
import QuickMenu from '@/components/Users/QuickMenu.vue';
import store from '@/store';

export default {
  name: 'Home',
  components: {
    Layout,
    QuickMenu,
  },
  async beforeRouteEnter(to, from, next) {
    const { dispatch } = store;
    await dispatch('setup');
    return next();
  },
};
</script>
